import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ci{background:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.ba{max-width:77.5rem;}.ssr-plugin'
import '.db{justify-content:stretch;}.ssr-plugin'
import '.dc{position:sticky;}.ssr-plugin'
import '.cy{top:0;}.ssr-plugin'
import '.dd{z-index:10;}.ssr-plugin'
import '.de{padding-block:1rem;}.ssr-plugin'
import '.df{height:3rem;}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import '.dg{flex-wrap:wrap;}.ssr-plugin'
import '.dh{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.be{margin-top:2rem;}.ssr-plugin'
import '.gd{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab b e ci"
      >
        <div className="bo a f b e"
        >
          <div className="ba a e db dc cy dd"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="de df a a0 f dg"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dh a e ab be gd ba"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
